import { useAddReport } from '@hooks/postQueries';
import { useUpdateReportTitle } from '@hooks/putQueries';
import CloseIcon from '@mui/icons-material/Close';
import { LoadingButton } from '@mui/lab';
import {
  Box,
  Divider,
  FormControl,
  FormLabel,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { Controller, useForm } from 'react-hook-form';
import { useParams } from 'react-router';

export default function StudyReportForm({ setOpen, studyType, editData }) {
  const { handleSubmit, control } = useForm({
    defaultValues: {
      title: editData?.title || '',
      sections: [{ name: '', description: '' }],
    },
  });

  const { id } = useParams();
  const queryClient = useQueryClient();

  const { mutate: addReport, isPending } = useAddReport();
  const { mutate: updateReport, isPending: isReportUpdating } = useUpdateReportTitle();

  const onSubmit = (data) => {
    const { title } = data;
    const formData = {
      title,
      study_id: id,
      study_type: studyType,
      sections: [
        {
          name: 'Untitled Section',
          description: 'Section description goes here',
        },
      ],
    };
    editData
      ? updateReport(
          { studyId: id, reportId: editData?.id, formData },
          {
            onSuccess: () => {
              setOpen(false);
              queryClient.invalidateQueries({ queryKey: ['reports'] });
            },
          },
        )
      : addReport(formData, {
          onSuccess: () => {
            setOpen(false);
            queryClient.invalidateQueries({ queryKey: ['reports'] });
          },
        });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box
        display={'flex'}
        alignItems={'center'}
        justifyContent={'space-between'}
        sx={{ px: 3, py: 1 }}
      >
        <Typography variant="subtitle2">Create Custom Report</Typography>
        <IconButton onClick={() => setOpen(false)}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider />
      <Box sx={{ px: 3, py: 2 }}>
        <FormControl fullWidth>
          <FormLabel>Report Name</FormLabel>
          <Controller
            name={`title`}
            rules={{ required: 'Report name is required' }}
            control={control}
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                variant="outlined"
                fullWidth
                error={!!error}
                helperText={error?.message}
              />
            )}
          />
        </FormControl>
      </Box>
      <Box>
        <Divider />
        <Box sx={{ display: 'flex', gap: 2, px: 3, py: 2 }}>
          <LoadingButton
            loading={isPending || isReportUpdating}
            type="submit"
            variant="contained"
            fullWidth
            sx={{ bgcolor: '#7C3AED', '&:hover': { bgcolor: '#6D28D9' } }}
          >
            {editData ? 'Update Report' : 'Create Report'}
          </LoadingButton>
        </Box>
      </Box>
    </form>
  );
}
